import { render, staticRenderFns } from "./Backend.vue?vue&type=template&id=a59e9f72&scoped=true"
import script from "./Backend.vue?vue&type=script&lang=js"
export * from "./Backend.vue?vue&type=script&lang=js"
import style0 from "./Backend.vue?vue&type=style&index=0&id=a59e9f72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59e9f72",
  null
  
)

export default component.exports